namespace SPA
{
	export namespace Realtor
	{
		export namespace gui
		{
			export class Address
			{
				public static Build(object: RealtorObjectModel): JQuery
				{
					const address = object.Address;
					const advData = object.AdvData;
					let imageSrc = 'assets/images/placeholder-image.png';
					const gms_id = address.GMS || (object.AdvData ? object.AdvData.gms_id : '');

					if (object.MainImage)
					{
						imageSrc = object.MainImage;
						if (imageSrc.indexOf('http') !== 0) {
							imageSrc = app.getRemotePath() + imageSrc;
						}
					}

					const stateSelect = new ui.Form.Select(
						{
							blank: '-- wird ausgefüllt --',
							name: 'state',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.Address.State)
						}, address.State || advData.state || ''
					);
					stateSelect.Initialize();

					const countrySelect = new ui.Form.Select(
						{
							name: 'country',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.Address.Country)
						}, address.Country || ''
					);
					countrySelect.Initialize();

					const template = $('<fieldset>')
						.append('<legend>Objekt-Adresse</legend>')
						.append(ui.$$.div().addClass('row')
							.append(ui.$$.div().addClass('col-sm-8 col-lg-7')
								.append(ui.$$.div().addClass('row')
									.append(
										SPA.gui.Bootstrap.Column('col-sm-8',
											new ui.base.BaseHTMLElement('label').addClass('control-label').text('Straße'),
											`<p class="form-control-static">${address.Street || advData.street}</p>`
										)
										.add(SPA.gui.Bootstrap.Column('col-sm-4',
											new ui.base.BaseHTMLElement('label').addClass('control-label').text('Haus-Nr.'),
											`<p class="form-control-static">${address.HouseNumber || advData.housenumber}</p>`
										))
										.add(`<input type="hidden" name="gms_id" value="${gms_id}">`)
									)
								)
								.append(ui.$$.div().addClass('row').append(
									SPA.gui.Bootstrap.Column('col-sm-4',
										new ui.base.BaseHTMLElement('label').addClass('control-label').text('PLZ'),
										`<p class="form-control-static">${address.PostalCode || advData.postalcode}</p>`
									)
										.add(SPA.gui.Bootstrap.Column('col-sm-8',
											new ui.base.BaseHTMLElement('label').addClass('control-label').text('Ort'),
											`<p class="form-control-static">${address.City || advData.city}</p>`
										))
										.add(SPA.gui.Bootstrap.Column('col-sm-6',
											new ui.base.BaseHTMLElement('label').addClass('control-label').text('Bundesland'),
											`<p class="form-control-static">${address.State ? SPA.types.Address.State[address.State] : advData.state ? SPA.types.Address.State[advData.state] : ''}</p>`
										))
										.add(SPA.gui.Bootstrap.Column('col-sm-6',
											new ui.base.BaseHTMLElement('label').addClass('control-label').text('Land'),
											'<p class="form-control-static" style="border:none">Deutschland</p>'
										))
									)
								)
							)
							.append(ui.$$.div().addClass('col-sm-4 col-lg-5')
								.append(ui.$$.div().addClass('row')
									.append(ui.$$.div().addClass('col-sm-12')
										.append(this.MainImage(object, imageSrc))
									)
								)
							)
						);

					return template;
				}

				public static MainImage(object: RealtorObjectModel, src: string): JQuery<HTMLElement>
				{
					const image = ui.$$.img()
						.addClass('doc-placeholder')
						.attr('src', src || 'assets/images/placeholder-image.png');

					const fileInput = document.createElement('input');
					fileInput.type = 'file';
					fileInput.name = 'main';
					$(fileInput).addClass('hidden').on('change', (e: Event) => {
						this.UploadImage(object, fileInput, image);
					});

					const btnNewImage = ui.$$.button()
						.addClass('btn btn-link')
						.css({float: 'right'})
						.on('click', (e) => {
							e.preventDefault();
							fileInput.click();
						})
						.append($('<i class="fas fa-plus-circle"></i> <span>Neues Bild</span>'));

					const previewArea = ui.$$.label().text('Hauptbild')
						.add(ui.$$.div().addClass('doc-preview')
							.append(image)
							.append(fileInput)
						).add(btnNewImage);

					previewArea.addClass("main-image");

					previewArea.on('dragover drop', (e) => {
						e.preventDefault();

						if (e.type === 'dragover') {
							// We have to capture dragover and drop for d&d to work
							return;
						}
						fileInput.files = e.originalEvent.dataTransfer.files;
						this.UploadImage(object, fileInput, image);
					});

					image.on('click', () =>
					{
						const element = document.createElement('img');
						element.src = image.attr('src');
						new ui.dialog.Modal({
							size: 'quick7',
							noCloseBtn: false,
							body: [
								$(element)
							]
						}).Show();
					});

					return previewArea;
				}

				private static UploadImage(object: RealtorObjectModel, file: HTMLInputElement, imageObject: JQuery)
				{
					const formData = new FormData();
					formData.append('main', file.files[0]);

					new Wollmilch.AJAX({
						url: 'object/mainimage/' + btoa(object.ObjectNumber),
						method: 'POST',
						data: formData,
						contentType: false,
						on: {
							success: (text) => {
								const response = JSON.parse(text);

								if (!response.success) {
									alert('Fehler beim ersetzen des Hauptbildes');
									return;
								}

								imageObject.attr('src', response.data.thumb);
								object.MainImage = response.data.main;
							}
						}
					}, AJAXCallbase_e.REALTOR).send();
				}
			}

		}
	}
}
